import type {ReactElement} from 'react';
import React from 'react';
import type {EditPosterSubtitlesPanelProps} from '@Panels/edit-poster-subtitles-panel/edit-poster-subtitles-panel.types';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {Modal} from '@Components/modal';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'edit-poster-subtitles-panel';

export default function EditPosterSubtitlesModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.EDIT_POSTER_SUBTITLES_MODAL];
  });

  return (
    <Modal modalId={MODALS_IDS.EDIT_POSTER_SUBTITLES_MODAL} panelId={PANEL_ID} modalHeight="500px" modalWidth="100%">
      <LazyPanel
        panelDirectoryName={PANEL_ID}
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openEditPosterSubtitlesModal = (props?: EditPosterSubtitlesPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EDIT_POSTER_SUBTITLES_MODAL,
      panelProps: {...props},
    })
  );
};
